import type { RecommendationByPlacementRequest } from 'autogen/swagger/all';
import { withErrorBoundary } from 'react-error-boundary';
import type { ProductRecommendationProps } from './types';
import { useRecoilValue } from 'recoil';
import { requestDataState } from 'recoilState/atoms/requestDataState';
import RecommendationLoader from 'components/productRecommendation/components/RecommendationLoader';
import styled from 'styled-components';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

const StyledRecommendationLoader = styled(RecommendationLoader)`
    && {
        padding-top: 0;
        padding-bottom: 0;
    }
`;

function ProductRecommendation(props: ProductRecommendationProps) {
    const {
        fields: { brand, product, productGroup, rawMobilePlacement, rawDesktopPlacement },
        sys: { id }
    } = props;
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    const { javascriptPageContext } = useRecoilValue(requestDataState);
    const { pageType } = javascriptPageContext;
    const model: RecommendationByPlacementRequest = {
        $type: 'RecommendationByPlacementRequest',
        brandId: Number(brand?.[0]?.sys?.urn) || undefined,
        productId: Number(product?.[0]?.sys?.urn) || undefined,
        productGroupId: Number(productGroup?.[0]?.sys?.urn) || undefined,
        mobilePlacementType: rawMobilePlacement,
        desktopPlacementType: rawDesktopPlacement || '',
        addToBasketType: undefined,
        pageType: pageType || 'None'
    };

    return <StyledRecommendationLoader model={model} {...inspectorProps({ fieldId: 'internalName' })} />;
}

export default withErrorBoundary(ProductRecommendation, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
